// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"15125":"2f239a7a5b94e033f4f9","25825":"35ffcbe96e7fd5a31de0","80020":"8114b3e840fe1abccc11"}[chunkId] + ".css";
};